import { useCallback } from 'react';

import { AddPartNoteButton, IPartNote } from 'bom/components';
import { IAddPartButtonProps, PartNoteType } from 'bom/components/AddPartNote';
import { useAgGridClientTableContext } from 'core/states';
import { IComponentNote } from 'jobs/types';
import { usePartBomItemNoteActions } from 'partBoms/hooks';
import { IPartBomItem, IPartBomItemNote } from 'partBoms/types';

interface IProps extends Omit<IAddPartButtonProps, 'upsertPartNoteAction' | 'onSubmitSuccess'> {
  partBomItem: IPartBomItem;
}

export const AddNoteButton = ({ partBomItem, ...rest }: IProps) => {
  const { updateRows } = useAgGridClientTableContext();

  const { upsertPartBomItemNote } = usePartBomItemNoteActions();

  const upsertPartNoteAction = useCallback(
    async (data: IPartNote) => {
      const { success, partBomItemNote } = await upsertPartBomItemNote({
        partBomItemNote: {
          ...data,
          partBomItemId: partBomItem?.id,
        },
      });

      return { success, partNote: partBomItemNote };
    },
    [partBomItem?.id, upsertPartBomItemNote]
  );

  const onPartNoteSubmitSuccess = useCallback(
    ({ partNotes }: { partNotes?: IComponentNote[] }) => {
      const prevNotes = partBomItem.notes || {};

      const updatedNotes: Record<string, IPartBomItemNote> = { ...prevNotes };

      if (partNotes) {
        partNotes.forEach((partNote: IComponentNote) => {
          updatedNotes[partNote.id as number] = {
            ...partNote,
            id: Number(partNote.id),
            type: PartNoteType.DEFAULT,
          };
        });
      }

      updateRows({
        update: [
          {
            ...partBomItem,
            notes: updatedNotes,
          },
        ],
      });
    },
    [partBomItem, updateRows]
  );

  return (
    <AddPartNoteButton
      upsertPartNoteAction={upsertPartNoteAction}
      onSubmitSuccess={onPartNoteSubmitSuccess}
      {...rest}
    />
  );
};
